// 参数格式化
export const pingParams = (targerParams) => {
  let str = '';
  for (const k in targerParams) {
    if (str !== '') {
      str += '&';
    };
    str += k + '=' + encodeURIComponent(targerParams[k]);
  };
  return str;
};

// 获取vue 组件名称
export const formatComponentName = (vm) => {
  if (vm.$root === vm) return 'root';
  var name = vm._isVue ?
    (vm.$options && vm.$options.name) ||
        (vm.$options && vm.$options._componentTag) :
    vm.name;
  return (
    (name ? 'component <' + name + '>' : 'anonymous component') +
        (vm._isVue && vm.$options && vm.$options.__file ?
          ' at ' + (vm.$options && vm.$options.__file) :
          '')
  );
};
